import "./projectList.scss";
import Card from "../../components/cards/card/Card";

import Map from "../../components/map/Map";

// import { useLoaderData } from "react-router-dom";
import { useLocation,useNavigate } from "react-router-dom";

import { useState, useEffect,useRef,useMemo } from "react";
import CurvedMenuToggle from "../../components/curvedToggleMenu/CurvedMenuToggle";
import usePaginatedList from "../../components/paginationlist/usePaginationList";
import ContainerLoader from "../../components/spinner/ContainerLoader";
import OverlayLoader from "../../components/spinner/OverlayLoader";

import PropertyTypeSlider from "../../components/basicslider/PropertyTypeSlider";
import { consumeObjectDraft } from "../../lib/objectReturnStore";
import ProjectCard from "../../components/cards/projectcard/ProjectCard";
import ProjectFilter from "../../components/projectfilter/projectfilter";


function ProjectListPage() {

  // default	        First load, no restored state, no navigation filters
  // restored	        Page comes back from detail view, state exists 
  // filterChanged	  User applies a filter manually or comes via navigation with filters
  // pageChanged	    User scrolls / paginates
    const location=useLocation();
    const pageLimit=10;
    const filterRef=useRef(null);
  

useEffect(() => {
  if (location.state) {
    // console.log("Filter changed:", location.state);
    applyNavFilters(location.state)
    // apply filter
  }
}, [location.state]);



// will have project filter for clientid i.e. developer,colonies,projectname, 
// will have budget filter later on as data does not specific price


// ✅ Load filters from location state or fallback to default
    const defaultFilters = {
        colonies: [],    // location
        clientid:[],    // developer
        projectname:null,  // projectname
        maxprice: 0,
        minprice: 0,
        bedroom: 0,
    };


// Merge location.state if user navigated with filters
  const navFilters = location.state
    ? { ...defaultFilters, ...location.state }
    : null;

// console.log("navFilters: ",navFilters);


  const storageKey = "projectListPage"; // unique key for this page
  const shouldRestore = !navFilters; // only means "eligible" to restore



// Initialize hook
const {
    items: projectposts,
    setItems,
    page,
    applyNavFilters, // the exposed function to apply filters
    loading,
    reloading,
    // setPage,
    hasMore,
    filters,
    // total,
    setFilters,

} = usePaginatedList("/projects", {
    limit: pageLimit,
    initialFilters: navFilters || defaultFilters,
    scrollContainerSelector: ".cardList",
    storageKey: storageKey,
    skipInitialFetch: false, // skip fetch if restoring 
    onRestore: (restored) => {
        // console.log("Restoration callback:", restored);

        if (filterRef.current) {
          filterRef.current.showFilter(restored.filters);
        }

        
      },

});


function restoreDraft() {

  const draft = consumeObjectDraft();
  if (!draft) return false;

  const returnedPost=draft.returnData;


  switch (draft.action) {

    case 'update':
      // console.log("now updating");

      setItems(prevPosts =>
        prevPosts.map(post => {
          // console.log("Checking post:", post.id, "against draft:", returnedPost.id);
          if (String(post.id) === String(returnedPost.id)) {
            // console.log("Updating post:", post, "with draft:", returnedPost);
            return { ...post, ...returnedPost };
          }
          return post;
        })
      );
      break;

    case 'add':
      // console.log("now adding");

      setItems(prevPosts => [returnedPost, ...prevPosts]);

      break;

    case 'delete':
      // console.log("now deleting");

      setItems(prevPosts =>
        prevPosts.filter(p => p.id !== returnedPost.id)
      );

      break;
  }

  // console.log("restored draft", draft);

  return true;
}



useEffect(() => {
  // to restore if coming back from savepost
  restoreDraft();
}, []);







  
//   const limit = 10; // Adjust to match your backend pagination limit
  const navigate = useNavigate();

  // --------------------------
  // 🔹 Mark a post as messaged (local UI update only)
  // --------------------------
  const markPostAsMessaged = (postId) => {

    setItems((prev) =>
      prev.map((post) =>
        post.id === postId ? { ...post, messaged: 1 } : post
      )
    );

  };


function getFileType(filenameOrUrl) {
  if (!filenameOrUrl) return "unknown";

  const ext = filenameOrUrl.split('.').pop().toLowerCase();

  // Simple extension checks
  const imageExt = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
  const videoExt = ['mp4', 'mov', 'avi', 'mkv', 'webm'];
  const docExt = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];

  if (imageExt.includes(ext)) return 'image';
  if (videoExt.includes(ext)) return 'video';
  if (docExt.includes(ext)) return 'document';

  return 'unknown';
}

const safeParse = (value, defaultValue) => {
  if (!value) return defaultValue;
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error("Failed to parse JSON:", e);
      return defaultValue;
    }
  }
  // already parsed
  return value;
};


// useEffect(() => {

//   if (!projectposts || projectposts.length === 0) return;

//   // console.log("Processing project posts for images and details...");
//   setItems(prevPosts =>
//     prevPosts.map(post => {
//       let builder = {};
//       let possession = {};
//       let configuration = [];
//       let brochure = [];
//       let imagedetails=[];
//       let otherimages=[];
//       let primedetails = [];
//       let media = [];
//       let images = [];

//       try {
//         // ---------- Parse JSON fields ----------

//         media = safeParse(post?.media || "[]"); 
 
//         images = media.map(m => {
//             const name = m.filename || m.sourceurl;
//             // decide file type
//             const file_type = m.file_type || getFileType(name || m.sourceurl);

//             return {
//               filename: name,
//               file_type
//             };
//           });
 

        

        
//         builder = safeParse(post?.builder || "{}");
//         possession = safeParse(post?.possession || "{}");
//         configuration = safeParse(post?.configuration || "[]");
//         brochure = safeParse(post?.brochure || "[]");
//         primedetails = safeParse(post?.primedetails || "[]");
//         imagedetails = safeParse(post?.imagedetails || "{}");
//         otherimages = safeParse(post?.otherimages || "[]");


  
//       } catch (e) {
//         console.error("Failed to parse project JSON fields:", e);
//       }

//       // ---------- Return updated post ----------
//       return {
//         ...post,
//         images,      // combined array for ProjectCard
//         imagedetails,
//         otherimages,
//         builder,
//         possession,
//         configuration,
//         brochure,
//         primedetails,
//         media        // raw media array
//       };
//     })
//   );
// }, [projectposts.length]);

const processedPosts = useMemo(() => {
  if (!projectposts || projectposts.length === 0) return [];

  return projectposts.map(post => {
    let media = [];
    let builder = {};
    // let possession = {};
    // let configuration = [];
    // let brochure = [];
    // let imagedetails = {};
    // let otherimages = [];
    // let primedetails = {};

    try {
      // ✅ Parse safely (handles string OR object)
      media = safeParse(post?.media, []);
      builder = safeParse(post?.builder, {});
      // possession = safeParse(post?.possession, {});
      // configuration = safeParse(post?.configuration, []);
      // brochure = safeParse(post?.brochure, []);

      // primedetails = safeParse(post?.primedetails, {});
      // imagedetails = safeParse(post?.imagedetails, {});
      // otherimages = safeParse(post?.otherimages, []);
    } catch (e) {
      console.error("Failed to parse project JSON fields:", e);
    }

    // ✅ Build images array from media
    const images = media.map(m => {
      const name = m.filename || m.sourceurl;

      return {
        filename: name,
        file_type: m.file_type || getFileType(name || m.sourceurl),
      };
    });

    return {
      ...post,
      media,
      images,
      builder,
      // possession,
      // configuration,
      // brochure,
      // primedetails,
      // imagedetails,
      // otherimages,
    };
  });

}, [projectposts]);







  return (
    <div className="listPage">
      {/* MAP SECTION */}
      <div className="mapContainer">
        {/* {console.log("Posts in maps: ", posts)} */}
        {/* {!loading ? (
          projectposts.length > 0 ? (
            <Map key={projectposts[0]?.id ?? "empty"} items={projectposts} />
          ) : (
            <p>No projects found</p>
          )
        ) : (
          // <p>Loading map…</p> // placeholder before hydration
          <ContainerLoader/>
        )} */}
      </div>

      {/* LIST SECTION */}
      <div className="listContainer">
        <div className="wrapper">

        

          <div className="ListPageAds">
            <PropertyTypeSlider
              PropertyTypes={[{id:'2',propertytype:'DDA Flat'},{id:'',propertytype:'builder floor'}]}
            >

            </PropertyTypeSlider>

          </div>
          
          <div className="FilterContainer">
            <CurvedMenuToggle
              curve="top"
              defaultOpen={false}
              menuColor="#e0e0e0"
              iconColor="#444"
            >
            <div> 
              <ProjectFilter
                ref={filterRef}
                filterOptions={navFilters} 
                // onFilterApply={handleFilterApply} 
                onFilterApply={(newFilters) => {
                  // console.log("Applying new filters:", newFilters);
                  applyNavFilters(newFilters); // ✅ call the hook’s function
                }}
              />

            </div>
            

            </CurvedMenuToggle>

          </div>



          <div className="cardList"  style={{ position: 'relative' }}>


            {/* {console.log("projectposts",projectposts)} */}
            {!loading ? (
              projectposts.length > 0 ? (


                processedPosts.map((post) => (

                  <ProjectCard
                    key={post.id}
                    item={post}
                    onMarkMessaged={() => markPostAsMessaged(post.id)}
                    // onNavigateSavePost={handleNavigateSavePost}
                    // onNavigatePostView={handleNavigatePostView}
                  />
                ))
              ):(
                <p>No posts found</p>
              )

            ) : (
              // <p>Loading Posts</p>
              <ContainerLoader/>
            )}


            {reloading && (
                <OverlayLoader 
                  position="sticky"
                  bottom={0}
                  text="Loading more..."
                  background= "rgba(200, 200, 200, 0.7)"
                  height="150px"

                />
              )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default ProjectListPage;
